import { CRM_COOKIES_CONSENT_KEY } from './../constants';
import Cookies from '../../../ports-frontend/Cookie';
import DeviceDetection from '../../../ports-frontend/DeviceDetection';
import { LogicContext } from '../types';

export const fetchCookieBannerInfo = async (context: LogicContext) => {
  const bannerCookieSet = await Cookies.get(CRM_COOKIES_CONSENT_KEY);
  const deviceInfo = await DeviceDetection.getDeviceInfo();
  const isIosNative =
    deviceInfo.isNative && deviceInfo.nativeDeviceOs === 'ios';
  return {
    cookieBannerVisible: bannerCookieSet === undefined && !isIosNative,
  };
};
